<template>
  <div v-html="headerHtml"></div>
</template>

<script>
  export default {
    data: function () {
      return {
        headerHtml: ''
      }
    },
    methods: {
      normalizeAssetPaths: function (html, baseUrl) {
        var parser = new DOMParser()
        var doc = parser.parseFromString(html, 'text/html')
        var attrs = ['src', 'href', 'data-base-src']
        attrs.forEach(function (attr) {
          var nodes = doc.querySelectorAll('[' + attr + ']')
          nodes.forEach(function (node) {
            var val = node.getAttribute(attr)
            if (!val) return
            if (val.startsWith('/') || val.startsWith('http') || val.startsWith('#') || val.startsWith('tel:') || val.startsWith('mailto:')) {
              return
            }
            node.setAttribute(attr, baseUrl + val)
          })
        })
        return doc.body.innerHTML
      }
    },
    mounted: function () {
      var baseUrl = process.env.BASE_URL || '/'
      fetch(baseUrl + 'header.html')
        .then(function (res) {
          if (!res.ok) {
            throw new Error('header.html load failed: ' + res.status)
          }
          return res.text()
        })
        .then(function (html) {
          this.headerHtml = this.normalizeAssetPaths(html, baseUrl)
          this.$nextTick(function () {
            if (window.snichiBindHeader) {
              window.snichiBindHeader()
            }
          })
        }.bind(this))
        .catch(function (e) {
          console.error(e)
        })
    }
  }
</script>
